// ============================================================================
// JAMB Question Bank — Literature
// Auto-split from QB.js for better code organisation
// ============================================================================

export const QB_LITERATURE = [

  {
    yr: 2024,
    q: "The village where only women lived in the novel is called?",
    o: ["Koidu", "Talaba", "Musudugu", "Musugudu"],
    a: 3,
    e: "Musugudu is the village where only women lived.",
    full: "In the novel, Musugudu is established as a community that consists solely of women. This setting serves as a key location for exploring themes of female autonomy and community away from patriarchal structures.",
    h: "Think about the mythical village associated with women."
  },
  {
    yr: 2024,
    q: "According to the novel, the children who are meant to show the path are called?",
    o: ["Dybo", "Breech", "Danketin", "Masuba"],
    a: 2,
    e: "The children are called Danketin.",
    full: "In the narrative, 'Danketin' refers to the designated children who guide or show the path, symbolizing the transmission of culture and knowledge to the next generation.",
    h: "Look for the term used for spiritual guides."
  },
  {
    yr: 2024,
    q: "So the Path Does Not Die is an example of a?",
    o: ["Historical novel", "Autobiographical novel", "Bildungsroman", "Gothic novel"],
    a: 2,
    e: "The novel is a Bildungsroman.",
    full: "A Bildungsroman focuses on the psychological and moral growth of the protagonist from youth to adulthood. 'So the Path Does Not Die' traces Finaba's journey, making it a classic example of this genre.",
    h: "The novel focuses on the growth of the main character."
  },
  {
    yr: 2024,
    q: "The protagonist of the novel is?",
    o: ["Finaba", "Nabou", "Cammy", "Baramusu"],
    a: 0,
    e: "Finaba is the protagonist.",
    full: "Finaba is the central character whose experiences, struggles, and development form the core narrative of the story.",
    h: "The story follows a young girl's journey."
  },
  {
    yr: 2024,
    q: "Finaba belongs to which ethnic group?",
    o: ["Temne", "Mende", "Fula", "Kono"],
    a: 2,
    e: "Finaba is a Fula.",
    full: "Finaba's Fula heritage is a significant aspect of her identity, influencing her experiences with tradition, migration, and belonging.",
    h: "She belongs to a pastoralist group often found across West Africa."
  },
  {
    yr: 2024,
    q: "Finaba and her parents were exiled from their village because?",
    o: ["they insisted on female circumcision", "they innocently killed Dimusu", "they could not conform to the traditions of the village", "they wanted Finaba to go to school"],
    a: 1,
    e: "They were exiled for innocently killing Dimusu.",
    full: "The accidental death of Dimusu leads to the family's exile, setting the stage for their subsequent migrations and struggles.",
    h: "The exile was caused by an accidental death."
  },
  {
    yr: 2024,
    q: "The setting of the novel includes?",
    o: ["Nigeria and Sierra Leone", "Liberia and Sierra Leone", "Sierra Leone and the United States", "Sierra Leone and the United Kingdom"],
    a: 2,
    e: "The novel is set in Sierra Leone and the United States.",
    full: "The narrative spans multiple locations, primarily shifting between the protagonist's homeland of Sierra Leone and her new life in the United States, highlighting the immigrant experience.",
    h: "The protagonist migrates to a Western country."
  },
  {
    yr: 2024,
    q: "The narrative technique used in the novel is mainly?",
    o: ["First person", "Second person", "Third person omniscient", "Third person limited"],
    a: 2,
    e: "The novel uses third person omniscient.",
    full: "The narrator knows the thoughts and feelings of multiple characters, providing a broad perspective on events and the internal lives of the cast.",
    h: "The narrator knows what many characters are thinking."
  },
  {
    yr: 2024,
    q: "The man who claims to be Cammy's son is?",
    o: ["Donovan, 21", "Gibson Glen, 22", "Glen Donovan, 21", "Glen Gibson, 21"],
    a: 3,
    e: "Glen Gibson, 21 is the man who claims to be Cammy's son.",
    full: "This character's claim adds complexity to the familial relationships and themes of paternity and legacy within the novel.",
    h: "The name has two parts."
  },
  {
    yr: 2024,
    q: "The character born breech in the prologue is?",
    o: ["Fina", "Masuba", "Kumba Kargbo", "Dimusu-Celeste"],
    a: 3,
    e: "Dimusu-Celeste is born breech.",
    full: "The circumstances of Dimusu-Celeste's birth are significant, marking her as a special or unusual character from the very beginning of the story.",
    h: "The character has a hyphenated name."
  },
  {
    yr: 2024,
    q: "In the novel, the Fulas are treated?",
    o: ["with love and respect", "as second-class citizens", "as innocent and kindly", "as political leaders"],
    a: 1,
    e: "The Fulas are treated as second-class citizens.",
    full: "The discrimination faced by the Fula people in the novel is a central theme, highlighting ethnic prejudice and marginalization.",
    h: "They face discrimination."
  },
  {
    yr: 2024,
    q: "The path in the novel symbolizes?",
    o: ["cultural continuity", "political authority", "economic growth", "religious freedom"],
    a: 0,
    e: "The path symbolizes cultural continuity.",
    full: "The 'path' is a powerful metaphor for the passage of traditions, customs, and a way of life from one generation to the next.",
    h: "It represents the preservation of heritage."
  },
  {
    yr: 2024,
    q: "Amazinga's original name is?",
    o: ["Anushka Muktari", "Celeste Priddy", "Elizabeth Anushka", "Dimusu-Celeste"],
    a: 0,
    e: "Amazinga's original name is Anushka Muktari.",
    full: "The choice to adopt a new name, 'Amazinga,' reflects her personal transformation and connection to a different identity.",
    h: "Her original name sounds South Asian."
  },
  {
    yr: 2024,
    q: "Amazinga's character is significant because?",
    o: ["she rejects African culture", "she accepts foreign culture", "she represents Africans who value and embrace their heritage", "she represents Americans who reject Africa"],
    a: 2,
    e: "She represents Africans who value and embrace their heritage.",
    full: "Amazinga serves as a positive model for the diaspora, demonstrating a conscious choice to connect with and honor her ancestral roots.",
    h: "She embraces her origins."
  },
  {
    yr: 2024,
    q: "The character who suffers sexual assault by a lecturer during her student years is?",
    o: ["Amazinga", "MawaF", "Edna", "Fina"],
    a: 1,
    e: "MawaF suffers sexual assault.",
    full: "MawaF's traumatic experience is a critical plot point that highlights issues of power, abuse, and vulnerability within academic and social institutions.",
    h: "The victim is not the main protagonist."
  },
  {
    yr: 2024,
    q: "MawaF's experience with Captain highlights?",
    o: ["the power of men over women", "the economic constraints in Africa", "sexual violence against women during the civil war", "the influence of Western culture"],
    a: 2,
    e: "It highlights sexual violence against women during the civil war.",
    full: "MawaF's story is used to draw attention to the widespread and brutal use of sexual violence as a weapon during the Sierra Leone civil war.",
    h: "This is connected to a major historical event in the novel."
  },
  {
    yr: 2024,
    q: "Fina marries Jemal mainly for?",
    o: ["love", "green card and immigration residency", "wealth", "companionship"],
    a: 1,
    e: "Fina marries Jemal mainly for a green card and immigration residency.",
    full: "This marriage of convenience underscores the desperate lengths immigrants may go to in order to secure legal status and a future in a new country.",
    h: "It's related to her legal status in America."
  },
  {
    yr: 2024,
    q: "Meredith's relationship with Fina in the novel can best be described as?",
    o: ["distant and formal", "hostile and competitive", "supportive and friendly", "strictly professional"],
    a: 2,
    e: "Their relationship is supportive and friendly.",
    full: "Meredith acts as a mentor and friend to Fina, providing crucial support and guidance as she navigates her new life.",
    h: "Meredith is a positive influence."
  },
  {
    yr: 2024,
    q: "The revelation that Meredith and Chip may have accepted a bribe from Sidibe Kakay suggests?",
    o: ["corruption is normal in Africa", "foreigners always reject corruption", "moral ideals may be compromised under pressure", "bribery is acceptable in politics"],
    a: 2,
    e: "It suggests that moral ideals may be compromised under pressure.",
    full: "This morally ambiguous situation shows that even principled characters can face dilemmas where their ideals conflict with practical or financial pressures.",
    h: "It's about a character's moral failing under pressure."
  },
  {
    yr: 2024,
    q: "Fina's journey to Kizzy's apartment symbolizes?",
    o: ["spiritual calling", "the curse from Baramusu", "psychological confusion and trauma", "the excitement of city life"],
    a: 2,
    e: "It symbolizes psychological confusion and trauma.",
    full: "The journey represents Fina's disoriented mental state as she grapples with past abuse and present uncertainties, marking a low point in her psychological arc.",
    h: "It's related to her mental state."
  },
  {
    yr: 2024,
    q: "The contrast between Kumba Kargbo and Finaba mainly illustrates?",
    o: ["myth versus realism", "tradition versus modernity", "destruction versus renewal", "power of women in nature"],
    a: 1,
    e: "It illustrates tradition versus modernity.",
    full: "Kumba Kargbo, a figure from legend, represents the old ways, while Finaba, living in the modern world, embodies the new, creating a central tension in the novel.",
    h: "This is a comparison of a legendary figure and a modern woman."
  },
  {
    yr: 2024,
    q: "Fina's decision to forgive Kizzy despite his abuse reflects?",
    o: ["weakness", "desire for revenge", "reconciliation and personal growth", "dependence on men"],
    a: 2,
    e: "It reflects reconciliation and personal growth.",
    full: "This difficult act of forgiveness is portrayed as a strength, allowing Fina to move past her trauma and achieve a more profound sense of peace and maturity.",
    h: "It's a sign of emotional maturity."
  },
  {
    yr: 2024,
    q: "The dominant motif in the novel is?",
    o: ["tourism and leisure", "communal love", "migration and identity struggle", "patriarchy and patriarchy"],
    a: 2,
    e: "The dominant motif is migration and identity struggle.",
    full: "The novel repeatedly explores the challenges of leaving one's homeland, adapting to new cultures, and the resulting questions of personal and cultural identity.",
    h: "This relates to moving between countries and finding oneself."
  },
  {
    yr: 2024,
    q: "Isa and her family become refugees mainly because of?",
    o: ["economic hardship", "religious persecution", "cultural disintegration", "civil war"],
    a: 3,
    e: "They become refugees because of the civil war.",
    full: "The brutal civil war in Sierra Leone is the primary catalyst that forces many characters, including Isa and her family, to flee their homes and seek safety elsewhere.",
    h: "This is caused by a major national conflict."
  },
  {
    yr: 2024,
    q: "Baramusu's position in Talaba symbolizes?",
    o: ["authority of traditional wisdom", "power of culture", "power of women", "colonial influence"],
    a: 0,
    e: "It symbolizes the authority of traditional wisdom.",
    full: "Baramusu acts as a respected elder and custodian of custom, his authority derived from his knowledge of traditional laws and spiritual matters.",
    h: "He is an elder who holds traditional knowledge."
  },
  {
    yr: 2024,
    q: "Isa and her husband sought refuge during the civil war in?",
    o: ["Nigeria", "Ivory Coast", "Guinea", "Ghana"],
    a: 2,
    e: "They sought refuge in Guinea.",
    full: "Guinea serves as a neighboring safe haven for those escaping the conflict in Sierra Leone.",
    h: "The country borders Sierra Leone."
  },
  {
    yr: 2024,
    q: "Fina's adoption of Mama Yegbe and Mafaw symbolizes?",
    o: ["cultural alienation", "emotional detachment", "cultural conservation", "nationalist ideology"],
    a: 2,
    e: "It symbolizes cultural conservation.",
    full: "By caring for the elderly Mama Yegbe, Fina actively preserves a link to her heritage and cares for the vulnerable, embodying a form of cultural preservation.",
    h: "It's about caring for elders and preserving a link to the past."
  },
  {
    yr: 2024,
    q: "The character who believes women are trophies that can be bought is?",
    o: ["Chip", "Sidibe Kakay", "Cammy", "Hassan"],
    a: 1,
    e: "Sidibe Kakay believes women are trophies.",
    full: "Sidibe Kakay's character is used to critique patriarchal attitudes that treat women as commodities to be owned and displayed.",
    h: "This character is depicted as corrupt and misogynistic."
  },
  {
    yr: 2024,
    q: "Anushka Muktari is?",
    o: ["Fina's best friend", "a colleague at Crowther College", "the woman impregnated by Cammy", "Cammy's elder sister"],
    a: 2,
    e: "Anushka Muktari is the woman impregnated by Cammy.",
    full: "Her pregnancy by Cammy is a significant plot point, affecting relationships and revealing character motivations.",
    h: "Her relationship with Cammy has major consequences."
  },
  {
    yr: 2024,
    q: "Fafei is regarded as?",
    o: ["a place where only men enter", "a place where only women enter", "a place where destinies are perfected by Atala", "circumcision hut"],
    a: 3,
    e: "Fafei is the circumcision hut.",
    full: "This location is central to the traditional ritual of female circumcision, a major point of conflict in the novel.",
    h: "It's the location for a controversial traditional practice."
  },
  {
    yr: 2024,
    q: "Fina's struggle to belong in different places highlights?",
    o: ["heroism", "love for Sierra Leone", "migration and identity struggle", "love and nationalism"],
    a: 2,
    e: "It highlights migration and identity struggle.",
    full: "Her repeated feelings of being an outsider—in Talaba, Freetown, and America—drive the novel's central exploration of how migration creates complex, often painful, questions of belonging.",
    h: "This is the core theme of the book."
  },
  {
    yr: 2024,
    q: "The death of Dimusu represents?",
    o: ["religious conflict", "cultural crisis", "ethnic prejudice", "political tension"],
    a: 1,
    e: "The death of Dimusu represents cultural crisis.",
    full: "The accidental killing and its aftermath expose deep fissures in the community, forcing a confrontation between traditional law and personal tragedy.",
    h: "The event triggers a major conflict with the community's laws."
  },
  {
    yr: 2024,
    q: "The hostility and discrimination faced by Fulas in the novel reflects?",
    o: ["cultural pride", "ethnic prejudice", "economic hardship", "cultural preservation"],
    a: 1,
    e: "It reflects ethnic prejudice.",
    full: "The treatment of the Fula characters serves as a direct commentary on the realities of ethnic discrimination and xenophobia within African societies.",
    h: "This is about unfair treatment based on a person's ethnic group."
  },
  {
    yr: 2024,
    q: "Baramusu's firm defense of circumcision represents?",
    o: ["resistance to Western culture", "political power of traditional leaders", "religious authority", "strict adherence to traditional beliefs"],
    a: 3,
    e: "It represents strict adherence to traditional beliefs.",
    full: "Baramusu is portrayed as an unwavering defender of custom, prioritizing the perceived spiritual and social necessity of the practice over individual well-being.",
    h: "He is a staunch traditionalist."
  },
  {
    yr: 2024,
    q: "Bayo's decision to return to Nigeria after studying abroad reflects?",
    o: ["cultural alienation", "the spirit of individualism", "the spirit of nationalism", "Western education influence"],
    a: 2,
    e: "It reflects the spirit of nationalism.",
    full: "Bayo's choice represents a commitment to use his education for the benefit of his home country, embodying a sense of patriotic duty.",
    h: "He wants to contribute to his homeland."
  },
  {
    yr: 2024,
    q: "The myth of Kumba Kargbo explores?",
    o: ["economic hardship", "acceptance of foreign traditions", "importance of proverbs", "resistance to oppressive traditions"],
    a: 3,
    e: "It explores resistance to oppressive traditions.",
    full: "The legendary figure of Kumba Kargbo is used to subtly critique and resist harmful traditional practices, offering a mythical precedent for change.",
    h: "The myth provides a framework for questioning certain customs."
  },
  {
    yr: 2024,
    q: "The refinement of the Musudugu legend suggests that?",
    o: ["traditions must never change", "change destroys communities", "modernity always wins", "traditions can be refined for better society"],
    a: 3,
    e: "It suggests traditions can be refined for a better society.",
    full: "The novel advocates for a dynamic view of culture, where traditions are not static but can be adapted and improved to serve the needs of a changing world.",
    h: "The novel suggests that customs should evolve."
  },
  {
    yr: 2024,
    q: "The title So the Path Does Not Die suggests that?",
    o: ["African traditions must remain unchanged", "migration solves African problems", "Africans should abandon bad practices", "cultural heritage should be preserved with reform"],
    a: 3,
    e: "It suggests cultural heritage should be preserved with reform.",
    full: "The title is a metaphor for keeping a culture alive, not by freezing it, but by allowing it to adapt and continue—thus, the 'path' of tradition continues.",
    h: "It's about the continuity of culture through adaptation."
  },
  {
    yr: 2024,
    q: "Finaba's experiences in Talaba, Freetown and America highlight that?",
    o: ["traditions must be challenged", "consequences of challenging traditions", "migration guarantees happiness", "belonging is a complex cultural struggle"],
    a: 3,
    e: "They highlight that belonging is a complex cultural struggle.",
    full: "Her journey across these different locations reveals that a sense of home is not easily found and is constantly negotiated through cultural, social, and personal conflicts.",
    h: "This is the ultimate lesson of the protagonist's journey."
  },
  {
    yr: 2024,
    q: "The conflict between Baramusu and Nabou represents?",
    o: ["myth versus reality", "culture versus religion", "tradition versus modernity", "political rivalry"],
    a: 2,
    e: "It represents tradition versus modernity.",
    full: "Their opposing views on practices like circumcision and the value of formal education embody the central clash between upholding the old ways and embracing the new.",
    h: "They disagree on the value of new ideas."
  },
  {
    yr: 2024,
    q: "Through Bayo and Finaba, the author suggests Africa's development requires?",
    o: ["rejection of Western ideas", "abandoning African practices", "nationalist commitment to rebuild Africa", "rejection of everything foreign"],
    a: 2,
    e: "It requires a nationalist commitment to rebuild Africa.",
    full: "By having educated characters like Bayo and Finaba return or wish to contribute to their home countries, the novel argues for a homegrown, dedicated effort towards Africa's progress.",
    h: "The characters show a dedication to their home countries."
  },
  {
    yr: 2024,
    q: "Amadu stops the circumcision ceremony because?",
    o: ["he fears punishment", "he believes Fina must go to school", "he dislikes villagers", "he believes the ritual is dangerous"],
    a: 1,
    e: "He stops it because he believes Fina must go to school.",
    full: "Amadu's intervention prioritizes Fina's education over the immediate demands of tradition, representing a modern, pragmatic perspective.",
    h: "He values formal education."
  },
  {
    yr: 2024,
    q: "Amazinga's adoption of an African name shows?",
    o: ["rejection of modern life", "admiration for African culture", "desire to belong to Africa", "academic research interest"],
    a: 2,
    e: "It shows admiration for African culture.",
    full: "Her choice is a deliberate act of identification with her African roots, demonstrating a respect and affection for the continent's heritage.",
    h: "It's about connecting with ancestral roots."
  },
  {
    yr: 2024,
    q: "Bayo represents Africans in the diaspora who?",
    o: ["totally reject Africa", "completely accept Africa", "feel responsible for developing Africa", "prefer Western culture"],
    a: 2,
    e: "He feels responsible for developing Africa.",
    full: "Bayo is a model of diasporic engagement, believing that those who have gained knowledge and skills abroad have a duty to return and contribute to the continent's betterment.",
    h: "He believes in giving back to his homeland."
  },
  {
    yr: 2024,
    q: "Mawa's character is important because she symbolizes?",
    o: ["survival and resilience after war trauma", "rebellion against traditions", "political activism", "corruption in African government"],
    a: 0,
    e: "She symbolizes survival and resilience after war trauma.",
    full: "Mawa's character arc, though marred by horrific violence, is ultimately one of survival, representing the strength of those who lived through the civil war.",
    h: "She is a survivor of terrible violence."
  },
  {
    yr: 2024,
    q: "Jemal's relationship with Fina mainly illustrates?",
    o: ["economic hardship", "struggles of love", "domestic violence", "immigration technicalities"],
    a: 3,
    e: "It mainly illustrates immigration technicalities.",
    full: "Their transactional marriage is a plot device used to explore the bureaucratic and legal hurdles faced by immigrants, rather than a relationship based on emotional connection.",
    h: "The relationship is a practical arrangement for legal status."
  },
  {
    yr: 2024,
    q: "The attempt to circumcise Fina is strongly supported by?",
    o: ["Baramusu", "Nabou", "Mama Jinah", "Mama Yegbe"],
    a: 0,
    e: "It is strongly supported by Baramusu.",
    full: "As the staunch traditionalist, Baramusu is the primary advocate for upholding the practice, placing him in direct opposition to Fina's future.",
    h: "This character is the main enforcer of tradition."
  },
  {
    yr: 2024,
    q: "Folklore elements in the novel help to?",
    o: ["reduce tension", "reinforce cultural identity", "weaken realism", "simplify plot"],
    a: 1,
    e: "They help to reinforce cultural identity.",
    full: "The integration of myths, legends, and proverbs grounds the story in a rich cultural heritage, affirming the value and continuity of these traditions.",
    h: "These elements connect the characters to their past."
  },
  {
    yr: 2024,
    q: "Judge and Celeste Priddy represent parents who?",
    o: ["enforce strict discipline", "prefer Western culture", "value reputation over morality", "oppose inequality"],
    a: 2,
    e: "They value reputation over morality.",
    full: "Their concern with public image, even when it requires covering up wrongdoing, is a critique of superficial values within certain social circles.",
    h: "They are concerned with how things look."
  },
  {
    yr: 2024,
    q: "Cutting the rope metaphorically refers to?",
    o: ["destroying family ties", "abandoning cultural connections", "breaking traditional laws", "escaping oppression"],
    a: 1,
    e: "It refers to abandoning cultural connections.",
    full: "The metaphor of cutting a rope symbolizes the severing of ties with one's heritage, traditions, and community, a central dilemma for many characters.",
    h: "It's about severing a link to one's past."
  },
  {
    yr: 2024,
    q: "The allegory of Musudugu mainly explores?",
    o: ["matriarchal possibility", "women can rule", "belonging and identity", "religious authority"],
    a: 2,
    e: "It mainly explores belonging and identity.",
    full: "The myth of the all-female village is an allegorical exploration of creating a space for female identity and community outside of patriarchal norms.",
    h: "It's about a community of women."
  },
  {
    yr: 2024,
    q: "The proverb Each plant and animal follows its own path emphasizes?",
    o: ["social order", "importance of farming", "strength of men", "rebellion"],
    a: 0,
    e: "It emphasizes social order.",
    full: "This proverb reinforces the idea that everyone has a prescribed role and destiny within the traditional social hierarchy.",
    h: "It's about accepting one's place."
  },
  {
    yr: 2024,
    q: "The proverb comparing men to elephant grass suggests?",
    o: ["men must dominate", "men disrupt women's growth", "men must guide women", "men always rule"],
    a: 1,
    e: "It suggests men disrupt women's growth.",
    full: "This proverb is used to illustrate how patriarchal power can overshadow and stunt the development and potential of women.",
    h: "It's about men getting in the way of women."
  },
  {
    yr: 2024,
    q: "The song sung by Kumba Kargbo after destruction of her village is an example of?",
    o: ["hymn", "satire", "dirge", "anthem"],
    a: 2,
    e: "It is an example of a dirge.",
    full: "A dirge is a lament for the dead, and the song serves as a mourning for the loss of her community and way of life.",
    h: "It's a song of mourning."
  },
  {
    yr: 2024,
    q: "Songs in the novel function mainly as?",
    o: ["historical documentation", "entertainment", "cultural preservation", "religious rituals"],
    a: 2,
    e: "They function mainly as cultural preservation.",
    full: "Songs are used to transmit history, values, and emotions across generations, acting as a living archive of the culture.",
    h: "They are a way to keep traditions alive."
  },
  {
    yr: 2024,
    q: "All the following are used in the novel except?",
    o: ["legend", "proverbs", "songs", "caricature"],
    a: 3,
    e: "Caricature is not a primary device used.",
    full: "While the novel uses rich folklore and oral traditions, it does not rely on exaggerated character portrayals or caricature as a main literary technique.",
    h: "This is not a form of oral tradition."
  },
  {
    yr: 2024,
    q: "The central motif of the novel is?",
    o: ["cultural assimilation", "rebellion", "migration and displacement", "corruption"],
    a: 2,
    e: "The central motif is migration and displacement.",
    full: "The physical and psychological movement of characters away from their homes and the resulting sense of dislocation is the most persistent and unifying theme.",
    h: "This is the core experience of the main character."
  },
  {
    yr: 2024,
    q: "Yoruba heritage in Sierra Leone highlights?",
    o: ["religious conversion", "political alliances", "colonial administration", "cultural migration during slave trade"],
    a: 3,
    e: "It highlights cultural migration during the slave trade.",
    full: "The presence of Yoruba culture in Sierra Leone is a historical legacy of the transatlantic slave trade and the subsequent settlement of liberated Africans in Freetown.",
    h: "It's a result of historical population movements."
  },
  {
    yr: 2024,
    q: "Dimusu-Celeste's dual names symbolize?",
    o: ["religious conversion", "political independence", "fusion of tradition and modernity", "social conflict"],
    a: 2,
    e: "They symbolize the fusion of tradition and modernity.",
    full: "The combination of a traditional African name (Dimusu) and a Western name (Celeste) represents the blending of two worlds and the dual identity of the character.",
    h: "It's a mix of an African and a Western name."
  },
  {
    yr: 2024,
    q: "The symbolic conflict between tradition and change is best illustrated through?",
    o: ["imagery", "dialogue", "proverbs", "legend of Kumba Kargbo"],
    a: 3,
    e: "It is best illustrated through the legend of Kumba Kargbo.",
    full: "The mythical story is the primary vessel for exploring the tension between adhering to custom and the need for reform, offering a framework for this central debate.",
    h: "This is a story from the past that comments on the present."
  },
  {
    yr: 2024,
    q: "Abandoning the path implies?",
    o: ["embracing modernity", "embracing education", "rejecting cultural identity", "travelling abroad"],
    a: 2,
    e: "Abandoning the path implies rejecting cultural identity.",
    full: "In the novel's central metaphor, leaving the 'path' means forsaking one's heritage, customs, and communal ties, leading to a loss of identity.",
    h: "This is about turning your back on your heritage."
  },
  {
    yr: 2024,
    q: "The symbolic meaning of the rope relates to?",
    o: ["cultural bondage", "physical bondage", "cultural roots", "migration"],
    a: 2,
    e: "It relates to cultural roots.",
    full: "The rope represents the connection to one's ancestors, traditions, and community—the ties that bind a person to their cultural identity.",
    h: "It's a metaphor for a connection to one's past."
  },
  {
    yr: 2024,
    q: "Baramusu insists female circumcision is?",
    o: ["unnecessary", "harmful", "compulsory rite of passage", "transition to manhood"],
    a: 2,
    e: "He insists it is a compulsory rite of passage.",
    full: "For Baramusu, the practice is an essential and non-negotiable tradition, a necessary step for a girl to become a full member of the community.",
    h: "He sees it as an obligatory custom."
  },
  {
    yr: 2024,
    q: "Finaba's parents leave Talaba because?",
    o: ["they want better future", "escape civil war", "better opportunities", "hostility from villagers"],
    a: 3,
    e: "They leave because of hostility from the villagers.",
    full: "The exile is a direct result of the villagers' antagonism following the accidental death of Dimusu, forcing them to flee their home.",
    h: "They were forced out by their community."
  },
  {
    yr: 2024,
    q: "Kizzy works at Crowther College as?",
    o: ["lecturer", "security guard", "administrator", "lab technician"],
    a: 1,
    e: "Kizzy works as a security guard.",
    full: "This job position reflects his social and economic standing within the American context, contrasting with his life in Sierra Leone.",
    h: "He has a low-wage job at the college."
  },
  {
    yr: 2024,
    q: "Koidu is famous for?",
    o: ["agriculture", "oil production", "fishing", "diamond mining"],
    a: 3,
    e: "Koidu is famous for diamond mining.",
    full: "The reference to Koidu grounds the novel in a real-world context, as the town is a known center for diamond mining in Sierra Leone, an industry linked to conflict.",
    h: "This is a resource-rich area."
  },
  {
    yr: 2024,
    q: "Jemal is portrayed as?",
    o: ["businessman", "drug addict", "diplomat", "soldier"],
    a: 0,
    e: "Jemal is portrayed as a businessman.",
    full: "His character is defined by his professional and entrepreneurial activities in the United States, which shapes his motivations and interactions.",
    h: "He is involved in commerce."
  },
  {
    yr: 2024,
    q: "Finaba argues Western condemnation of circumcision is?",
    o: ["hypocritical and culturally biased", "politically motivated", "exaggerated", "overstated"],
    a: 0,
    e: "She argues it is hypocritical and culturally biased.",
    full: "Finaba challenges the Western perspective by pointing out its own cultural biases and failures, arguing for a more nuanced understanding of the practice.",
    h: "She believes Westerners judge without understanding."
  },
  {
    yr: 2024,
    q: "Finaba later works in Freetown as?",
    o: ["politician", "akara seller", "rehabilitation centre manager", "women's rights activist"],
    a: 2,
    e: "She works as a rehabilitation centre manager.",
    full: "This job is a direct response to the social problems caused by the war, allowing her to contribute to the healing of her community.",
    h: "She manages a facility to help people."
  },
  {
    yr: 2024,
    q: "Cammy eventually decides to?",
    o: ["return to America", "abandon Finaba", "join Finaba in Sierra Leone", "marry Amazinga"],
    a: 2,
    e: "He decides to join Finaba in Sierra Leone.",
    full: "Cammy's decision to move to Sierra Leone represents a commitment to Finaba and her world, bridging the gap between their different backgrounds.",
    h: "He makes a major life change to be with her."
  },
  {
    yr: 2024,
    q: "Kumba Kargbo in the legend was said to be?",
    o: ["born blind", "born after prayer", "born during ritual", "born breech"],
    a: 3,
    e: "She was said to be born breech.",
    full: "This unusual birth detail marks Kumba Kargbo as a special or chosen figure from the very start, setting her apart in the legend.",
    h: "Her birth was not the normal way."
  },
  {
    yr: 2024,
    q: "Kumba Kargbo leaves Musudugu to?",
    o: ["find enemies", "live in city", "escape punishment", "search for knowledge"],
    a: 3,
    e: "She leaves to search for knowledge.",
    full: "Her quest is for understanding and wisdom, making her a figure of enlightenment and change, rather than a mere rebel.",
    h: "She is on a quest for understanding."
  },
  {
    yr: 2024,
    q: "The novel spans roughly from?",
    o: ["1960s-70s", "1970s-early 2000s", "1990s-2010s", "colonial era"],
    a: 1,
    e: "The novel spans roughly from the 1970s to the early 2000s.",
    full: "This timeframe allows the narrative to encompass the pre-war period, the civil war itself, and the subsequent diaspora experience.",
    h: "This covers the period before, during, and after the civil war."
  },
  {
    yr: 2024,
    q: "The Sierra Leone war lasted?",
    o: ["5 years", "6 years", "11 years", "20 years"],
    a: 2,
    e: "The Sierra Leone war lasted 11 years.",
    full: "The brutal civil war in Sierra Leone is a historical fact that lasted from 1991 to 2002, a period of 11 years.",
    h: "This is a real historical fact."
  },
  {
    yr: 2024,
    q: "Freetown was historically established by the British as?",
    o: ["trading post", "military base", "settlement for freed slaves", "slave market"],
    a: 2,
    e: "It was established as a settlement for freed slaves.",
    full: "The founding of Freetown is a key historical event, making it a unique city for former slaves from the British Empire and the Americas.",
    h: "The city was founded as a home for liberated people."
  },
  {
    yr: 2024,
    q: "Crowther College symbolically represents?",
    o: ["Fourah Bay College", "Oxford", "Harvard", "University of Sierra Leone"],
    a: 0,
    e: "Crowther College symbolically represents Fourah Bay College.",
    full: "Fourah Bay College is a real and prestigious institution in Freetown, and the fictional Crowther College serves as its analogue within the novel.",
    h: "This is a well-known university in Freetown."
  },
  {
    yr: 2023,
    q: 'This question is based on RAIDER OF THE TREASURE TROVE.\nThe poetic device in the expression "Rage is chief" is ___',
    o: ['Oxymoron', 'Simile', 'Metaphor', 'Hyperbole'],
    a: 2,
    e: '"Rage is chief" directly equates Rage with a position of authority — no "like" or "as" — making it a metaphor.',
    full: 'A metaphor makes a direct comparison by saying one thing IS another. "Rage is chief" states that Rage holds the position of chief — a direct equation of an abstract emotion (Rage) with a concrete role (chief).\n\n• Simile: would say "Rage is LIKE a chief"\n• Oxymoron: two contradictory terms side by side (e.g., "bitter sweet")\n• Hyperbole: extreme exaggeration\n\nThis is from the poem "Raider of the Treasure Trove" — a prescribed JAMB poetry text.',
    h: 'What device equates Rage directly with the position of chief?',
  },
  {
    yr: 2023,
    q: '__________ are generally regarded as brief but purposeful references, within a literary text, to a person, place, event, or to another work of literature.',
    o: ['Referrals', 'Chiasmus', 'Metonymy', 'Allusions'],
    a: 3,
    e: 'Allusions are indirect, brief references within a text to another person, place, event, or literary work to invoke deeper meaning.',
    full: 'An allusion is when a writer briefly references something outside the text — a historical event, a mythological figure, a famous work — without fully explaining it, trusting the reader to make the connection.\n\nExamples:\n• "He was a real Romeo" (alludes to Shakespeare\'s Romeo and Juliet)\n• "She opened a Pandora\'s box" (alludes to Greek myth)\n\n• Chiasmus: reversal of grammatical structures in successive phrases (e.g., "Ask not what your country can do for you...")\n• Metonymy: using a related word in place of another (e.g., "the Crown" for the monarchy)\n\nThe key definition — "brief but purposeful reference to a person, place, event, or another work" — is allusion.',
    h: 'What literary device makes brief references to external people, places, or texts?',
  },
  {
    yr: 2023,
    q: '"Be him English\nBe him African\nBe him Nigerian"\n\nThe lines above are an example of ___',
    o: ['Epigram', 'Anaphora', 'Epitaph', 'Tautology'],
    a: 1,
    e: 'Anaphora is the repetition of the same word or phrase at the beginning of successive lines or clauses. "Be him" is repeated at the start of each line.',
    full: 'Anaphora: the deliberate repetition of a word or phrase at the beginning of successive lines, clauses, or sentences for rhetorical or poetic effect.\n\nHere "Be him" opens every line — creating rhythm, emphasis, and a building sense of identity.\n\nDistinctions:\n• Epigram: a short, witty, pointed saying\n• Epitaph: an inscription on a tomb or a short tribute to the dead\n• Tautology: needless repetition of the same idea in different words (redundancy)\n\nAnaphora adds emotional weight and poetic momentum — it is one of the most frequently tested devices in JAMB Literature.',
    h: 'What is the device of repeating the same words at the start of each successive line?',
  },
  {
    yr: 2023,
    q: 'From Wole Soyinka\'s "The Beautification of Area Boy":\n"I can shave the head of an entire battalion between one coup and the next."\n\nThe literary devices in this dialogue are ___',
    o: ['Hyperbole and allusion', 'Irony and parody', 'Allusion and paradox', 'Humour and irony'],
    a: 0,
    e: 'The claim of shaving a whole battalion between coups is hyperbole (wild exaggeration); the reference to coups and soldiers is an allusion to Nigeria\'s political history.',
    full: 'Two devices operate simultaneously:\n\n1. Hyperbole: "shave the head of an entire battalion between one coup and the next" — this is a wildly exaggerated boast. No barber could literally do this; it is meant to emphasise his speed and reputation.\n\n2. Allusion: the reference to "coup" and "soldiers" is an indirect allusion to Nigeria\'s history of military coups — a politically charged reference that situates the play in a real socio-political context.\n\nThis is a question based on Wole Soyinka\'s play, which JAMB frequently uses for literary device identification.',
    h: 'Which two devices appear in the barber\'s boast about shaving battalions between coups?',
  },
  {
    yr: 2023,
    q: 'A structural arrangement of units of composition by which one element of equal importance with another is similarly placed is called ___',
    o: ['Repetition', 'Paradox', 'Refrain', 'Parallelism'],
    a: 3,
    e: 'Parallelism is the structural arrangement where grammatically equal elements are placed in similar positions to create balance and emphasis.',
    full: 'Parallelism creates balance in writing by using the same grammatical form for equal ideas.\n\nExample: "He came, he saw, he conquered." (Three short independent clauses of equal structure)\n\nThe key phrase in the question is "elements of equal importance... similarly placed" — this is parallelism.\n\n• Repetition: simply saying the same word/phrase again — does not require structural equality\n• Paradox: a statement that seems contradictory but reveals a deeper truth\n• Refrain: a repeated line or stanza in a poem/song (like a chorus)\n\nParallelism is a structural device; the others are not.',
    h: 'What device places equally important elements in similarly structured grammatical positions?',
  },
  {
    yr: 2023,
    q: 'A story with elements that have both literal and figurative meanings is ___',
    o: ['Allegory', 'Novella', 'Fable', 'Epistle'],
    a: 0,
    e: 'An allegory is a narrative where characters, events, and settings function on both a literal level and a deeper symbolic/figurative level simultaneously.',
    full: 'An allegory operates on two levels at once:\n• Literal: the surface story (characters, events, places)\n• Figurative/symbolic: the deeper meaning (moral, political, spiritual truth)\n\nExamples:\n• George Orwell\'s Animal Farm: literally about farm animals rebelling, figuratively about the Russian Revolution and totalitarianism\n• Bunyan\'s Pilgrim\'s Progress: a literal journey that allegorises the Christian spiritual journey\n\n• Fable: a short story with animals that teaches a moral lesson — a type of allegory but more specific\n• Novella: a medium-length realistic fiction — not specifically symbolic\n• Epistle: a letter-format literary work',
    h: 'What narrative form has both literal and deeper symbolic meanings throughout?',
  },
  {
    yr: 2023,
    q: 'The plot of the Jibunoh passage ("Jibunoh was simply a difficult man... his death elicited jubilation") is ___',
    o: ['Linear', 'Cyclical', 'Achronological', 'Convoluted'],
    a: 0,
    e: 'The story moves in a straightforward, chronological sequence from Jibunoh\'s character to his death — this is a linear plot.',
    full: 'Plot types:\n• Linear: events unfold in chronological sequence from beginning to end — the most straightforward structure.\n• Cyclical: the story ends where it began, completing a full circle.\n• Achronological: events are not in time order — uses flashbacks, flash-forwards, non-linear jumps.\n• Convoluted: excessively complex, tangled plot.\n\nThe Jibunoh passage describes his life characteristics and then his death, in a direct sequence — this is a linear plot. There are no flashbacks or non-linear jumps.',
    h: 'What type of plot moves in straightforward chronological order?',
  },
  {
    yr: 2023,
    q: 'Dramatis personae in a play refers to ___',
    o: ['Cast list', 'List of characters', 'Protagonist and antagonist', 'Order of appearance'],
    a: 1,
    e: 'Dramatis personae is a Latin term meaning "persons of the drama" — it is the list of all characters in a play, usually printed at the beginning.',
    full: '"Dramatis personae" (Latin: persons of the drama) is the printed list of all characters in a play, typically found at the front of the script before the play begins.\n\nDistinctions:\n• Cast list: refers to the actors who PERFORM the roles (not the characters themselves)\n• Protagonist and antagonist: specific types of characters — not all characters\n• Order of appearance: describes the sequence in which characters come on stage\n\nDramatis personae = the complete list of characters (not actors, not just leads) ✓',
    h: 'What Latin term refers to the list of characters in a play?',
  },
  {
    yr: 2023,
    q: 'A trilogy is the ___',
    o: [
      'Set of three one-act dramas written by related authors',
      'Series of related stories divided into three equal parts',
      'Sequence of three plays written by the same author',
      'Collection of three poems of equal length',
    ],
    a: 2,
    e: 'A trilogy is a set of three closely related literary works (plays, novels, films) by the same author, connected by character, theme, or narrative.',
    full: 'A trilogy consists of three related works by the same creator:\n• Plays: e.g., Aeschylus\'s Oresteia (three connected tragedies)\n• Novels: e.g., The Lord of the Rings\n• Films: e.g., The Godfather trilogy\n\nKey features: same author, connected narratively or thematically, three parts.\n\nThe options compare subtle differences — "written by related authors" (A) is wrong; "divided into three equal parts" (B) implies one work split three ways; "collection of three poems" (D) is too specific and inaccurate.\n\nC: "sequence of three plays written by the same author" ✓ — captures the essential definition.',
    h: 'What is a trilogy — three works by the same or different authors?',
  },
  {
    yr: 2023,
    q: 'The exclusive right given to authors to protect their works from unlawful reproduction is ___',
    o: ['An authority to write', 'A copyright', 'An author\'s right', 'A constitutional provision'],
    a: 1,
    e: 'Copyright is the legal protection given to creators of original works, giving them exclusive rights over reproduction, distribution, and adaptation of their work.',
    full: 'Copyright is an intellectual property right that:\n• Grants the creator exclusive control over their work\n• Prevents others from copying, distributing, or adapting without permission\n• Lasts for the creator\'s lifetime plus a set number of years\n• Applies to literary, dramatic, musical, and artistic works\n\nIn Nigeria: the Copyright Act (as amended) governs copyright protection.\nInternationally: the Berne Convention provides global copyright standards.\n\n"A copyright" is the specific legal term — not "author\'s right" (informal) or "constitutional provision" (too broad).',
    h: 'What legal protection prevents unlawful reproduction of an author\'s work?',
  },
  {
    yr: 2023,
    q: '"The fair breeze blew / The white foam flew / The furrow followed free..."\n\nThe dominant figure of speech in the above passage is ___',
    o: ['Repetition', 'Alliteration', 'Paradox', 'Rhyme scheme'],
    a: 1,
    e: 'Alliteration is the repetition of the same initial consonant sound in closely connected words. "fair...flew," "white...foam," "furrow...followed...free" all demonstrate this.',
    full: 'Alliteration: the repetition of the same initial consonant sound in successive or closely connected words.\n\nFrom "The Rime of the Ancient Mariner" by S.T. Coleridge:\n• "fair breeze blew" → f, b, b\n• "white foam flew" → wh, f, fl\n• "furrow followed free" → f, f, f\n\nThe f-sound dominance across the stanza is the most striking feature — making alliteration the dominant device.\n\n• Repetition: repeating the same word — not the case here (no word repeats)\n• Rhyme scheme: end-rhyme pattern — secondary here, not "dominant"\n• Paradox: contradictory statement — not present',
    h: 'What is the dominant device when the same initial consonant sounds repeat across lines?',
  },
  {
    yr: 2023,
    q: 'From "The Journey of the Magi" — "And running away, and wanting their liquor and women, / And the night-fires going out, and the lack of shelters, / And the cities hostile and the towns unfriendly"\n\nThe dominant device in this excerpt is ___',
    o: ['Metaphor', 'Synecdoche', 'Simile', 'Paradox'],
    a: 3,
    e: 'EduPadi\'s verified answer is paradox — the cities being "hostile" and towns "unfriendly" while the Magi travel in supposed peace creates a paradoxical situation. Note: anaphora (repetition of "And") is also very prominent but not in the options.',
    full: 'This excerpt from T.S. Eliot\'s "Journey of the Magi" catalogues the hardships of travel with a cumulative "And...And...And" structure (anaphora).\n\nEduPadi identifies the dominant device as paradox — the contradictions embedded in the journey: the Magi travelling with holy purpose but experiencing hostility, desire, and discomfort.\n\nHowever, strictly speaking, anaphora (the repeated "And" at line starts) is more visually dominant — but since anaphora is not among the options, JAMB\'s accepted answer is paradox based on the contradictory conditions described.\n\nIn exam settings, go with the verified answer: paradox (D).',
    h: 'What device is identified in the Magi\'s contradictory journey conditions?',
  },
  {
    yr: 2023,
    q: 'From Cameron Daodu\'s "The Gab Boys" — the passage mocks poorly written application letters. The tone of the passage is ___',
    o: ['Melancholic', 'Ironic', 'Harsh', 'Derisive'],
    a: 3,
    e: 'The tone is derisive — the passage mocks the pompous, error-filled language of application letters, holding them up for ridicule.',
    full: 'Tone describes the author\'s attitude toward the subject matter.\n\nThe passage reproduces a comically over-formal, grammatically incorrect application letter ("rendered you the greatest services... at my desposition to your best satisfactory") — and then notes that English proficiency is still required for white-collar jobs.\n\nThis is derisive: mocking, scornful, ridiculing. The author holds the letters up to ridicule while also critiquing the colonial educational system that created this situation.\n\n• Melancholic: sad, sorrowful — not the primary tone here\n• Ironic: some irony is present but "derisive" captures the mockery more precisely\n• Harsh: too blunt; the mockery is more subtle/literary',
    h: 'What tone involves mockery and ridicule of its subject?',
  },
  {
    yr: 2023,
    q: '"Don\'t panic. Be calm. If you are somehow upset...try to regain your composure."\n\nThe speaker in the excerpt above is ___',
    o: ['Hopeless', 'Afraid', 'Confident', 'Uncertain'],
    a: 2,
    e: 'The speaker\'s calming, instructive tone — giving clear directions to not panic and regain composure — projects confidence and control.',
    full: 'The speaker is issuing calm, direct instructions: "Don\'t panic. Be calm. Regain your composure." This is the voice of someone in control, who is reassuring others.\n\nA hopeless speaker would express despair.\nAn afraid speaker would express fear.\nAn uncertain speaker would hedge and qualify.\n\nThe directness and reassurance in the commands project confidence — the speaker knows what must be done and calmly communicates it.',
    h: 'What does issuing calm reassuring instructions reveal about a speaker\'s state of mind?',
  },
  {
    yr: 2023,
    q: 'An action in a play that stimulates the audience to pity a character is ___',
    o: ['Props', 'Parody', 'Pyrrhic', 'Pathos'],
    a: 3,
    e: 'Pathos is the quality in a play (or any literary work) that evokes pity, sadness, or tender emotion in the audience toward a character.',
    full: 'Pathos (from Greek: πάθος, "suffering" or "feeling") is the element that moves the audience to pity or emotional compassion for a character.\n\nAristotle identified pity and fear as the two core emotions tragedy evokes — pathos relates to pity.\n\n• Props: physical objects used on stage\n• Parody: a comic imitation of a serious work\n• Pyrrhic: a metrical foot of two unstressed syllables (in poetry prosody) — not about emotion\n• Pathos ✓: the quality that evokes pity',
    h: 'What theatrical quality evokes pity in the audience for a character?',
  },
  {
    yr: 2023,
    q: 'Lineation refers to ___',
    o: [
      'The arrangement of lines in verse form',
      'The grouping together of a number of units of rhythm',
      'The unit in the rhythmic structure of verse',
      'Tracing family descent of people in verse',
    ],
    a: 0,
    e: 'Lineation is the way a poet arranges and breaks text into lines — decisions about where lines begin and end, and how this affects rhythm and meaning.',
    full: 'Lineation: the division of a poem into lines — the decisions a poet makes about where to end one line and begin another.\n\nLineation affects:\n• Rhythm: line breaks create natural pauses\n• Emphasis: what falls at the end of a line gets emphasis\n• Meaning: enjambment (running over) vs end-stopped lines\n\nDistinctions:\n• B describes stanza (grouping lines into rhythmic units)\n• C describes a metrical foot (the basic rhythmic unit: iamb, trochee, etc.)\n• D is completely unrelated (genealogy)\n\nLineation = the arrangement of lines in verse form ✓',
    h: 'What term describes how a poet divides text into lines?',
  },
  {
    yr: 2023,
    q: 'The use of two contrasting words that are placed side by side is called ___',
    o: ['Oxymoron', 'Euphemism', 'Pun', 'Antithesis'],
    a: 0,
    e: 'An oxymoron places two contradictory or opposite terms directly together to create a paradoxical expression — e.g., "bittersweet," "deafening silence."',
    full: 'Oxymoron: two contradictory terms placed TOGETHER (side by side) in the same expression.\n\nExamples: "living death," "cold fire," "sweet sorrow," "bittersweet"\n\nDistinctions:\n• Antithesis: contrast between two COMPLETE IDEAS or clauses (broader opposition, not necessarily two words side by side)\n  Example: "To err is human, to forgive divine."\n• Euphemism: a mild word used instead of a harsh one (e.g., "passed away" for "died")\n• Pun: a play on the multiple meanings of a word\n\nThe key phrase is "two contrasting words... placed side by side" — this specifically defines oxymoron.',
    h: 'Two contradictory words placed directly together = oxymoron or antithesis?',
  },
  {
    yr: 2023,
    q: 'The passage about Jibunoh reveals that he symbolises ___',
    o: ['Insanity', 'Wickedness', 'Lawlessness', 'Isolation'],
    a: 2,
    e: 'Jibunoh\'s disregard for social norms, his legal cases for theft and rights violations, and his beating of a policeman all point to him as a symbol of lawlessness.',
    full: 'Jibunoh\'s actions in the passage:\n• Hated by neighbours and deserted by relations\n• Beat a policeman\n• Had ten legal cases for stealing and violating others\' rights\n• Had no regard for "decency or normal conduct"\n• His death brought jubilation, not mourning\n\nAll of these speak to a pattern of defying laws, norms, and social rules — making him a symbol of lawlessness.\n\n• Insanity: not implied — his behaviour is deliberate, not irrational\n• Wickedness: partially true but narrower — lawlessness is more encompassing\n• Isolation: he is socially isolated as a consequence, but that is a result not a symbol',
    h: 'Jibunoh beats police, steals, violates rights — what does he primarily symbolise?',
  },
  {
    yr: 2023,
    q: 'The tragic character is the person whose experiences arouse pity and ___',
    o: ['Sympathy', 'Terror', 'Horror', 'Frustration'],
    a: 1,
    e: 'According to Aristotle\'s Poetics, tragedy must evoke pity AND fear (terror) in the audience through the protagonist\'s downfall — this is catharsis.',
    full: 'Aristotle\'s theory of tragedy (from Poetics):\n• Tragedy must arouse two emotions: pity and fear (phobos/terror)\n• Pity: we feel sorry for the tragic hero\'s suffering\n• Fear/Terror: we recognise that the same fate could befall us\n• The combination of these two emotions produces catharsis (emotional release/purification)\n\nThis is one of the most fundamental concepts in literary studies and a perennial JAMB question.\n\n"Terror" (B) is the precise Aristotelian term — not sympathy, horror, or frustration.\n\nMemory tip: "pity and FEAR" = Aristotle\'s two emotions of tragedy.',
    h: 'According to Aristotle, tragedy arouses pity and what other emotion?',
  },
  {
    yr: 2023,
    q: '"Rage is chief / Rage drags rags after you, of Charity / Laughter, sweetness and light, Rage is thief / Enemy of equanimity"\n\nThe figure of speech dominant in these lines is ___',
    o: ['Apostrophe', 'Personification', 'Metaphor', 'Simile'],
    a: 1,
    e: 'Rage is given human attributes — being a "chief," a "thief," capable of dragging things — making personification the dominant device.',
    full: 'Personification: giving human qualities, actions, or feelings to abstract ideas or non-human things.\n\nIn these lines from "Raider of the Treasure Trove":\n• "Rage is chief" — Rage holds a human leadership position\n• "Rage drags rags after you" — Rage performs a human physical action\n• "Rage is thief" — Rage commits a human crime\n• "Enemy of equanimity" — Rage has human adversarial relationships\n\nNote: Q1 (page 1) asked about JUST "Rage is chief" and the answer was metaphor. Here the full stanza is given, and the DOMINANT device across the whole stanza is personification — Rage performing multiple human actions and roles.\n\nThis distinction is important: a single comparison = metaphor; sustained human attributes across a whole poem = personification.',
    h: 'When Rage is given human roles and actions throughout a full stanza, what is the dominant device?',
  },
  {
    yr: 2023,
    q: '"Cast" in a play refers to ___',
    o: ['Three of the actors', 'A few of the actors', 'An exclusive social class in the play', 'All the actors'],
    a: 3,
    e: 'The cast of a play refers to ALL the actors who perform in it — the entire company of performers.',
    full: '"Cast" in theatrical context refers to all the performers in a production — every actor who has a role, from lead to supporting to minor parts.\n\n• "Dramatis personae" = list of characters\n• "Cast" = all the actors performing those characters\n\nThe distinction between cast (all actors) and dramatis personae (all characters) is a common JAMB trap.',
    h: 'Does "cast" mean some actors or all actors in a play?',
  },
  {
    yr: 2023,
    q: 'A formal dignified speech or writing praising a person or thing for past or present deeds is ___',
    o: ['Lampoon', 'Eulogy', 'Premiere', 'Anthology'],
    a: 1,
    e: 'A eulogy is a formal, dignified speech or piece of writing offering high praise for a person\'s deeds and character — commonly delivered at funerals but not exclusively.',
    full: 'Eulogy (from Greek: eu = well + logos = word) = speaking well of someone.\n\nA eulogy is a formal tribute that:\n• Praises a person\'s achievements and virtues\n• Is delivered at funerals but can be given for living people (e.g., retirement speeches)\n• Has a dignified, serious tone\n\nDistinctions:\n• Lampoon: a sharp, satirical piece that ATTACKS or ridicules a person\n• Premiere: the first performance/showing of a play, film, etc.\n• Anthology: a collection of literary works by various authors on a theme\n\nLampoon (ridicule) vs Eulogy (praise) is a common JAMB opposition.',
    h: 'What is a formal, dignified tribute praising someone\'s deeds — the opposite of a lampoon?',
  },
  {
    yr: 2023,
    q: 'This question is based on BAT by D.H. Lawrence.\n"Bat! Creatures that hang themselves up like an old rag, to sleep, And disgustingly upside down."\n\nThe theme of this excerpt is ___',
    o: [
      'All of the above',
      'The poet\'s right to individual choice',
      'The poet\'s admiration of the beauty of nature',
      'The poet\'s appalling remarks about the bird',
    ],
    a: 3,
    e: 'The excerpt expresses the poet\'s disgust and negative opinion of bats — their peculiar sleeping habits are described as disgusting, making the dominant theme his appalling remarks about the bat.',
    full: 'In D.H. Lawrence\'s "Bat," the poet uses contemptuous, negative language to describe bats:\n• "hang themselves up like an old rag" — compared to rubbish\n• "disgustingly upside down" — the word "disgustingly" leaves no doubt\n\nThe tone and language reflect revulsion and disdain — the poem is essentially an extended negative description of bats.\n\nThe theme is the poet\'s appalling (negative, harsh) remarks about the bat.\n\n• B (individual choice): not what the poem is about\n• C (admiration of nature): the complete opposite — this is disdain\n• A (all of the above): impossible since B and C contradict the actual poem',
    h: 'What is the theme when a poet uses disgusted language about an animal?',
  },
  {
    yr: 2023,
    q: 'From Festus Iyayi\'s "Violence" — the woman commands "Get dressed and let\'s go." The speaker can be described as ___',
    o: ['Hungry', 'Domineering', 'Friendly', 'Treacherous'],
    a: 1,
    e: 'The speaker issues commands, controls the situation, and sets conditions ("if we are going to meet again... it won\'t be here") — all signs of a domineering personality.',
    full: 'Character description based on speech and action:\n\n• She "checks herself" — showing self-control\n• Issues commands: "Get dressed," "let\'s go"\n• Makes unilateral decisions about future meetings and location\n• "Slaps the bed" — physical expression of authority\n\nAll of these actions suggest someone who controls the interaction and makes decisions for others — domineering.\n\n• Friendly: would be warm and accommodating, not commanding\n• Treacherous: implies betrayal — not evidenced here\n• Hungry: no mention of food',
    h: 'What word describes someone who gives commands, controls situations, and dictates terms?',
  },
  {
    yr: 2023,
    q: 'The combination of two or more metaphors is called ___',
    o: ['Monometaphor', 'Dymetaphor', 'Mixed metaphor', 'Combined metaphor'],
    a: 2,
    e: 'A mixed metaphor combines elements of two or more metaphors that often don\'t logically cohere — sometimes creating an unintentionally absurd or confusing image.',
    full: 'Mixed metaphor: the result of combining two or more metaphors, especially when they clash or don\'t logically fit together.\n\nExample: "We need to grab the bull by the horns and iron out the wrinkles" — combining a bull metaphor with an ironing metaphor.\n\n"Monometaphor" and "dymetaphor" are not real literary terms — they are distractors. "Combined metaphor" is not a standard term either.\n\n"Mixed metaphor" is the established, standard term in literary criticism for the combination of two or more metaphors.',
    h: 'What is the standard term for combining two or more metaphors?',
  },
  {
    yr: 2023,
    q: 'A metrical pause occurring in the middle of a line in a poem is called ___',
    o: ['Tetrameter', 'Rhythm', 'Caesura', 'Assonance'],
    a: 2,
    e: 'A caesura is a natural pause or break in the middle of a line of verse, often marked by punctuation, that creates rhythm and emphasis.',
    full: 'Caesura (from Latin: a cutting): a pause within a line of poetry.\n\nExample from "Beowulf": "To err is human, || to forgive divine" — the || marks the caesura.\n\nCaesuras:\n• Create breathing points within long lines\n• Break the line into two rhythmic halves (hemistich)\n• Add emphasis and variety to the rhythm\n\nDistinctions:\n• Tetrameter: a line of poetry with four metrical feet (not a pause)\n• Rhythm: the overall pattern of stressed and unstressed syllables\n• Assonance: repetition of vowel sounds within words\n• Caesura ✓: specifically the mid-line pause',
    h: 'What is the term for a pause in the middle of a poetic line?',
  },
  {
    yr: 2023,
    q: 'From Ibiwari Ikiriko\'s "Oily Tears" — "These oily tears... Will one day be staunched, I swear!"\n\nThe tone of the poet is ___',
    o: ['Supplicatory', 'Optimistic', 'Sympathetic', 'Piteous'],
    a: 1,
    e: 'The poet\'s promise that the tears "will one day be staunched" projects hope and confidence about the future — an optimistic tone.',
    full: '"Oily Tears" by Ibiwari Ikiriko deals with the environmental devastation of oil pollution in the Niger Delta.\n\nThe poet speaks directly to the suffering people, and the closing promise — "Will one day be staunched, I swear!" — is an oath of hope. Despite the pain, the poet believes relief and justice will come.\n\nThis forward-looking, hopeful assurance = optimistic tone.\n\n• Supplicatory: pleading, begging — not the case (the poet makes a promise, not a plea)\n• Sympathetic: feeling sorry for another — present but not the dominant tone\n• Piteous: expressing pitifulness — the poet is promising, not lamenting',
    h: 'When a poet swears that suffering "will one day be staunched," what is the tone?',
  },
  {
    yr: 2023,
    q: 'An extended fictional narrative which is realistic is known as a ___',
    o: ['Short story', 'Diary', 'Novella', 'Novel'],
    a: 3,
    e: 'A novel is an extended, realistic work of prose fiction — longer and more complex than a short story or novella, dealing in depth with human experience.',
    full: 'Prose fiction hierarchy by length:\n• Flash fiction: very short (under 1,000 words)\n• Short story: brief narrative (1,000–20,000 words)\n• Novella: medium-length (20,000–60,000 words)\n• Novel: extended, full-length realistic fiction (60,000+ words)\n\nThe key words are "extended" AND "realistic":\n• Extended: distinguishes from short story and novella\n• Realistic: distinguishes from fantasy, myth, allegory\n\nA diary is a non-fiction personal journal, not a fictional narrative.\nA novella is shorter than a novel.\n\nAnswer: Novel ✓',
    h: 'What is the term for a long, realistic prose fiction work?',
  },
  {
    yr: 2023,
    q: '"The sun used to smile in my hut."\n\nThe line is an example of ___',
    o: ['Apostrophe', 'Personification', 'Rhetorical question', 'Zeugma'],
    a: 1,
    e: 'The sun is given the human ability to "smile" — attributing a human action to a non-human thing makes this personification.',
    full: 'Personification: giving human qualities (emotions, actions, characteristics) to non-human things or abstractions.\n\n"The sun used to smile" — the sun is not human, but here it "smiles" — a distinctly human expression of happiness and warmth.\n\nDistinctions:\n• Apostrophe: addressing an absent person, a dead person, or an abstract quality directly (e.g., "O Death, where is thy sting?")\n• Rhetorical question: a question asked for effect without expecting an answer\n• Zeugma: one verb applied to two nouns in different senses (e.g., "She lost her keys and her temper")\n\nThe "smile" given to the sun = personification ✓',
    h: 'What device gives the sun the human ability to smile?',
  },
  {
    yr: 2023,
    q: 'A tragic hero, according to the Aristotelian precept, must be a ___',
    o: [
      'Central character after whom the play is named',
      'King with deep affection for his subjects',
      'Noble character with hubris',
      'Lowly character who suddenly stumbles on some fortunes',
    ],
    a: 2,
    e: 'Aristotle\'s tragic hero must be of noble status (high birth) and have a hamartia — often hubris (excessive pride/arrogance) — that leads to their downfall.',
    full: 'Aristotle\'s definition of a tragic hero (from Poetics):\n1. Noble/high status: must be a person of standing — a king, general, nobleman (not a common person)\n2. Hamartia: a tragic flaw — most commonly hubris (excessive pride/arrogance) but can be other flaws\n3. Anagnorisis: a moment of recognition/discovery\n4. Peripeteia: reversal of fortune\n5. The downfall must arouse pity and fear\n\nExamples: Oedipus Rex, Hamlet, Macbeth — all noble with fatal flaws.\n\n• A (named after): not a requirement\n• B (king with affection): too specific and sentimental\n• C (noble with hubris) ✓\n• D (lowly character): directly contradicts Aristotle — the hero must be noble, not lowly',
    h: 'What two qualities define Aristotle\'s tragic hero — noble status and what flaw?',
  },
  {
    yr: 2023,
    q: 'From John Donne\'s "A Valediction: Forbidding Mourning" — "As virtuous men pass mildly away..."\n\nThe tone of this poem is generally ___',
    o: ['Conversational', 'Imaginative', 'Serious', 'Appreciative'],
    a: 2,
    e: 'The poem deals with separation, death, and the spiritual bond between lovers — these weighty, earnest themes give the poem a serious tone throughout.',
    full: 'John Donne\'s "A Valediction: Forbidding Mourning" is a metaphysical poem in which the speaker addresses his departing lover, arguing that true spiritual love transcends physical separation.\n\nThe poem\'s tone is serious because:\n• It opens with dying men (solemn, grave imagery)\n• It makes philosophical arguments about the nature of love\n• It employs elaborate conceits (the compass metaphor)\n• The subject — separation and death — demands gravitas\n\nWhile the poem is imaginative (it uses creative conceits), "serious" best captures the overall attitude and weight of the poem.',
    h: 'What tone characterises a poem about death, separation, and the nature of spiritual love?',
  },
  {
    yr: 2023,
    q: 'This question is based on THE LION AND THE JEWEL.\nThe indication that Soyinka\'s play is culturally set is its use of ___',
    o: ['Dance and songs', 'Flashback', 'Foreshadowing', 'Irony'],
    a: 0,
    e: 'Soyinka\'s The Lion and the Jewel is set in a Yoruba village and uses dance, songs, and mime to portray cultural rituals — making these the clearest indicator of its cultural setting.',
    full: 'Wole Soyinka\'s "The Lion and the Jewel" is set in the fictional Yoruba village of Ilujinle. Its cultural setting is most powerfully indicated by:\n\n• Dance and mime sequences: characters literally act out historical events through dance\n• Songs: traditional Yoruba songs are incorporated\n• These are not decorative but structural — entire scenes are communicated through dance and song rather than dialogue\n\nThis is a specifically African theatrical device that sets the play apart from Western drama and grounds it firmly in Yoruba cultural tradition.\n\nFlashback, foreshadowing, and irony are universal literary devices not unique to any culture.',
    h: 'What uniquely African theatrical elements confirm The Lion and the Jewel\'s cultural setting?',
  },
  {
    yr: 2023,
    q: 'Which of these is the oldest genre of literature?',
    o: ['Aroma', 'Poetry', 'Drama', 'Prose'],
    a: 1,
    e: 'Poetry is the oldest genre of literature — it predates writing, originating in oral traditions of ancient civilisations as chants, hymns, and epic narratives.',
    full: 'Historical order of literary genres:\n\n1. Poetry (oldest): Oral poetry predates all writing — ancient Mesopotamian hymns, Homer\'s Iliad and Odyssey (oral epics before being written down), African oral poetry traditions. Poetry was the first literary form because it uses rhythm and repetition to aid memorisation in pre-literate cultures.\n\n2. Drama: emerged in ancient Greece around 5th century BCE (Aeschylus, Sophocles, Euripides)\n\n3. Prose: the novel as a form is relatively recent — developed mainly in the 17th–18th centuries\n\nNote: "Aroma" is not a genre of literature — it appears to be a distractor.',
    h: 'Which literary genre came first — poetry, drama, or prose?',
  },
  {
    yr: 2023,
    q: 'From William Blake\'s poem — "And so Tom awoke...Tom was happy and warm; / So if all do their duty they need not fear harm."\n\nTom is warm because he ___',
    o: ['Is working indoors', 'Is wearing warm clothes', 'Is doing his duty', 'Has just woken from sleep'],
    a: 2,
    e: 'The poem explicitly states the reason for Tom\'s warmth: "So if all do their duty they need not fear harm" — duty-fulfilment brings inner warmth and peace.',
    full: 'This is from William Blake\'s "The Chimney Sweeper" (Songs of Experience). After Tom\'s dream of liberation (where an Angel promises freedom to faithful chimney sweeps), Tom wakes happy and warm.\n\nThe poem\'s moral — "if all do their duty they need not fear harm" — makes clear that Tom\'s warmth is not physical (it is cold and dark morning), but spiritual/moral: the warmth of contentment from fulfilling one\'s duty.\n\nBlake uses this poem to both comfort child labourers AND critique a society that exploits children by telling them to be content with their fate. The "warmth from duty" is bittersweet.',
    h: 'Why is Tom warm despite the cold morning — physical warmth or moral contentment from duty?',
  },
  {
    yr: 2023,
    q: 'Using the name of one thing for something else with which it is closely associated is ___',
    o: ['Paradox', 'Parody', 'Parallelism', 'Metonymy'],
    a: 3,
    e: 'Metonymy substitutes the name of one thing for another closely associated thing — e.g., "the Crown" for the monarchy, "the pen" for writing.',
    full: 'Metonymy: replacing a word with a closely associated word.\n\nExamples:\n• "The White House announced..." (White House = US President/administration)\n• "The pen is mightier than the sword" (pen = writing; sword = military force)\n• "Hollywood" for the film industry\n• "Aso Rock" for the Nigerian presidency\n\nDistinction from synecdoche:\n• Synecdoche: part represents whole or whole represents part (e.g., "wheels" for a car)\n• Metonymy: an associated thing stands in for another (not necessarily part-whole)\n\nDistinctions from options:\n• Paradox: a contradictory statement with deeper truth\n• Parody: comic imitation\n• Parallelism: balanced structural arrangement',
    h: 'What device uses a closely associated word in place of another — "the Crown" for the monarchy?',
  },
  {
    yr: 2023,
    q: 'This question is based on CAGED BIRD by Maya Angelou.\n"for the caged bird / sings of freedom"\n\nThe poetic device used in this expression is ___',
    o: ['Metaphor', 'Irony', 'Hyperbole', 'Paradox'],
    a: 1,
    e: 'The caged bird singing OF freedom despite being caged — wanting what it cannot have — is situational irony: the reality (captivity) directly contradicts the desire (freedom).',
    full: 'Maya Angelou\'s "Caged Bird" uses the contrast between a free bird and a caged bird to explore themes of oppression and freedom.\n\n"The caged bird sings of freedom" — this is ironic because:\n• The bird is caged (captive, no freedom)\n• Yet it sings about freedom (the very thing denied to it)\n• This contradiction between circumstance and desire = situational irony\n\nNote: Some might argue this is also metaphor (the caged bird symbolises oppressed people) — but the specific device operating in the EXPRESSION "sings of freedom" while caged is irony.\n\nJAMB\'s verified answer: B — irony.',
    h: 'What device is at work when a caged bird sings about the very freedom it is denied?',
  },
  {
    yr: 2023,
    q: 'The term given to a type of incident or device which recurs frequently in Literature is ___',
    o: ['Concept', 'Myth', 'Ritual', 'Motif'],
    a: 3,
    e: 'A motif is a recurring element — image, idea, symbol, or narrative pattern — that appears repeatedly throughout a work or across literary works, contributing to theme.',
    full: 'Motif: a recurring element that carries symbolic significance throughout a literary work.\n\nExamples:\n• Light and darkness in Romeo and Juliet\n• Water as a symbol of rebirth across literature\n• The "journey" as a motif in many novels\n• Betrayal recurring throughout a play\n\nDistinctions:\n• Theme: the central message or insight of the work\n• Motif: a specific recurring element that contributes to theme\n• Myth: a traditional story with cultural/religious significance\n• Ritual: a set pattern of ceremonial actions\n• Concept: a broad idea (not specifically literary)',
    h: 'What is the term for an element that recurs throughout a literary work with symbolic significance?',
  },
  {
    yr: 2023,
    q: 'From Cynthia James\'s "Drumology" — "My heart is a quiet drum... flares like a parched thunder cracking through a damask sky"\n\nThe imagery in the excerpt above is largely ___',
    o: ['Olfactory and visual', 'Auditory and visual', 'Tactile and auditory', 'Olfactory and tactile'],
    a: 1,
    e: 'The passage appeals to sound (drum, thunder — auditory) and sight (damask sky, fired spectacle — visual), making the imagery primarily auditory and visual.',
    full: 'Types of imagery (sensory appeals):\n• Visual: what we see\n• Auditory: what we hear\n• Tactile: what we feel/touch\n• Olfactory: what we smell\n• Gustatory: what we taste\n\nIn the excerpt:\n• "quiet drum" → auditory (sound)\n• "flares like a parched thunder cracking" → auditory (thunder sound)\n• "damask sky" → visual (a rich visual image)\n• "fired spectacle" → visual (something seen)\n\nAuditory + Visual are the two dominant image types.\n\n• Olfactory (smell): not present\n• Tactile (touch): not dominant',
    h: 'Which two senses — hearing and sight — are evoked by drums, thunder, and skies?',
  },
  {
    yr: 2023,
    q: 'The subject matter of a literary work is the ___',
    o: ['Theme', 'Plot', 'Structure', 'Setting'],
    a: 0,
    e: 'The subject matter — the underlying concern or central idea — of a literary work is its theme.',
    full: 'Literary terms:\n• Theme: the central idea, message, or subject matter of a work — what the work is fundamentally ABOUT (e.g., love, war, identity, justice)\n• Plot: the sequence of events that make up the narrative (WHAT HAPPENS)\n• Structure: how the work is organised (chapters, acts, stanzas, etc.)\n• Setting: where and when the story takes place\n\nThe "subject matter" — what the work concerns itself with at its deepest level — is the theme.\n\nExample: The subject matter of "Things Fall Apart" is the clash of cultures and the collapse of traditional society under colonialism. This is its theme.',
    h: 'What literary term means the central concern or "what the work is about"?',
  },
  {
    yr: 2023,
    q: 'The sides of a stage are called ___',
    o: ['Both sides', 'The ways', 'The wings', 'The pits'],
    a: 2,
    e: 'The wings are the areas to the left and right sides of a stage — out of the audience\'s view — where actors wait and stagehands work.',
    full: 'Theatre terminology:\n\n• Wings: the off-stage areas to the sides of the performance area — hidden from the audience, used by actors awaiting entrances and stagehands managing props and set changes\n\n• Pit/Orchestra pit: the sunken area in front of the stage where the orchestra plays in traditional theatres\n\n• Backstage: area behind the stage\n\n• Apron/Forestage: the part of the stage that extends in front of the main curtain\n\n• Proscenium: the arch framing the stage\n\n"Wings" is the standard theatrical term for the sides of a stage.',
    h: 'What are the off-stage areas to the left and right sides of a performance stage called?',
  },
  {
    yr: 2023,
    q: 'Using the name of one thing for something else with which it is closely associated in an instance is ___\n[Note: Duplicate question from Page 4 of 2023 — metonymy]',
    o: ['Paradox', 'Parody', 'Parallelism', 'Metonymy'],
    a: 3,
    e: 'Metonymy substitutes the name of one thing with the name of something closely associated — e.g., "the pen is mightier than the sword."',
    full: 'See previous metonymy entry above for full explanation.',
    h: 'What device substitutes a closely associated name for another thing?',
  },
  {
    yr: 2023,
    q: 'The term given to recurring incidents or devices in literature is ___\n[Motif — verified]',
    o: ['Concept', 'Myth', 'Ritual', 'Motif'],
    a: 3,
    e: 'A motif is a recurring literary element — image, symbol, situation — that appears throughout a text and contributes to its theme.',
    full: 'See previous motif entry above for full explanation.',
    h: 'What is the literary term for a repeatedly occurring element that carries symbolic significance?',
  },
    {
      yr: 2024,
      q: "'All the world's a stage' is from",
      o: [
        'Charles Dickens',
        'William Shakespeare',
        'John Keats',
        'John Milton',
      ],
      a: 1,
      e: 'This line is from As You Like It by William Shakespeare.',
      full: "All the world's a stage, and all the men and women merely players — this is one of the most famous speeches in all of English literature. It comes from Act 2, Scene 7 of As You Like It by William Shakespeare, spoken by the melancholy character Jaques.\n\nIn the speech, Jaques compares the entire world to a theatrical stage and all human beings to actors, then divides human life into seven ages from infancy to old age. It is a beautiful and profound metaphor on the nature of life.\n\nCharles Dickens was a Victorian novelist. John Keats and John Milton were poets. Shakespeare was the playwright whose work is central to English Literature in JAMB.",
      h: 'Which playwright compared the world to a stage?',
    },
    {
      yr: 2024,
      q: 'First person narration uses pronoun',
      o: ['He/She', 'They', 'I/We', 'You'],
      a: 2,
      e: 'First person uses I (singular) or We (plural).',
      full: 'In literature, the narrative perspective tells us who is telling the story and what point of view the story is told from.\n\nFirst person narration uses "I" (when one narrator tells their own story) or "we" (when multiple narrators share the telling). The narrator is a character within the story with direct access to their own thoughts but limited knowledge of others\' inner thoughts.\n\nSecond person uses "you" — rare in fiction, common in instruction manuals and some experimental writing. Third person uses "he," "she," "they" — the narrator stands outside the story, either with limited perspective (third person limited) or all-knowing (third person omniscient).',
      h: 'First person = the narrator speaks as themselves.',
    },
    {
      yr: 2023,
      q: 'An epic is a',
      o: [
        'Short lyric poem',
        'Long narrative poem about heroic deeds',
        'Comedy play',
        'Short story',
      ],
      a: 1,
      e: 'An epic is a long narrative poem celebrating heroic deeds.',
      full: 'The epic is one of the oldest and grandest literary forms. Epic poems tell the story of a hero — often of national or cosmic importance — who undergoes extraordinary adventures and battles. They are long, formal, and elevated in style.\n\nThe classic epics include Homer\'s Iliad and Odyssey (ancient Greece), Virgil\'s Aeneid (Rome), and Beowulf (Old English). African epics include the Sundiata epic of West Africa.\n\nA lyric poem is short and expressive of personal emotion (like a song). A comedy is a type of drama, not a narrative poem. A short story is prose, not poetry. Only "long narrative poem about heroic deeds" correctly defines the epic form.',
      h: 'Think Iliad and Odyssey. Long, heroic, narrative.',
    },
    {
      yr: 2024,
      q: 'The climax of a story is',
      o: [
        'The beginning',
        'The point of highest tension',
        'The end',
        'The resolution',
      ],
      a: 1,
      e: 'The climax is the most intense turning point in a narrative.',
      full: 'Every story follows a plot structure. It begins with exposition (introduction of characters and setting), then rises through complications and conflict (rising action), reaches the moment of greatest tension and decision (climax), then begins to resolve (falling action), and finally ends (resolution or denouement).\n\nThe climax is the peak of the story — the moment when the central conflict comes to a head. In Hamlet, the climax is the duel and multiple deaths in Act 5. In a thriller, it might be the confrontation between hero and villain.\n\nThe beginning is the exposition. The end is the resolution. The climax is specifically the turning point of highest tension — not the ending itself.',
      h: 'Highest point of tension in the plot.',
    },
    {
      yr: 2023,
      q: 'A soliloquy is when a character',
      o: [
        'Speaks to another',
        'Speaks alone to express inner thoughts',
        'Sings on stage',
        'Writes a letter',
      ],
      a: 1,
      e: 'A soliloquy is a character speaking thoughts aloud when alone.',
      full: 'The soliloquy is a theatrical device in which a character is alone on stage (or believes themselves to be alone) and speaks their inner thoughts aloud for the audience to hear. The audience gains privileged insight into the character\'s true feelings, plans, and conflicts — information that other characters in the play do not have.\n\nShakespeare used soliloquies extensively. Hamlet\'s "To be or not to be" is the most famous soliloquy in English literature — Hamlet alone, contemplating suicide and the meaning of existence.\n\nA dialogue is a conversation between two or more people. An aside is a brief private comment to the audience, not a full speech. A soliloquy is always solo and always expressive of inner thoughts.',
      h: 'Solo = alone. A character speaks their mind to no one.',
    },
    {
      yr: 2022,
      q: 'Dramatic irony occurs when',
      o: [
        'Characters are dramatic',
        'Audience knows more than characters',
        'Plot is surprising',
        'Ending is unexpected',
      ],
      a: 1,
      e: 'Dramatic irony is when the audience has knowledge that characters do not.',
      full: 'Irony is the gap between what is expected or understood and what is actually happening. Dramatic irony is specifically when the AUDIENCE knows something important that the characters on stage do not know.\n\nThis creates tension because the audience watches characters make decisions, say things, or walk into danger — unaware of what the audience already knows. In Romeo and Juliet, the audience knows Juliet is not actually dead when Romeo finds her in the tomb. Romeo does not know. The tragedy that follows is powered entirely by dramatic irony.\n\nSituational irony is when events turn out opposite to expectations. Verbal irony is when someone says the opposite of what they mean. Dramatic irony is the audience-versus-character knowledge gap.',
      h: "The audience knows something the characters don\'t.",
    },
    {
      yr: 2024,
      q: 'A protagonist is',
      o: [
        'The villain',
        'The main character',
        'A minor character',
        'The narrator',
      ],
      a: 1,
      e: 'The protagonist is the central character around whom the story revolves.',
      full: 'In any narrative — novel, film, play, or short story — the protagonist is the main character whose journey, conflict, and development drives the story forward. The entire plot is structured around what happens to the protagonist and what choices they make.\n\nThe word comes from the Greek protos (first) and agonist (actor or contestant). Protagonists need not be morally good — they just need to be the central figure. Macbeth is the protagonist of his play despite being the villain.\n\nThe antagonist opposes the protagonist. A minor character has a small role. The narrator tells the story but may or may not be the main character.',
      h: 'Proto = first/main. Who is the story mainly about?',
    },
    {
      yr: 2023,
      q: "Direct comparison without 'like' or 'as'",
      o: ['Simile', 'Metaphor', 'Hyperbole', 'Alliteration'],
      a: 1,
      e: 'A metaphor makes a direct comparison without the words like or as.',
      full: 'Both similes and metaphors make comparisons, but they do it differently.\n\nA simile uses the words "like" or "as" to signal the comparison: "He is like a lion." "She ran as fast as the wind." The comparison is explicit.\n\nA metaphor states the comparison directly, without any signal words: "He is a lion." "She was the wind." The thing being described IS something else — not merely similar to it.\n\nHyperbole is exaggeration for effect: "I\'ve told you a million times." Alliteration is the repetition of initial consonant sounds: "Peter Piper Picked..."',
      h: 'Direct = metaphor. Using like/as = simile.',
    },
    {
      yr: 2022,
      q: "'The pen is mightier than the sword' is",
      o: ['Alliteration', 'Hyperbole', 'Metaphor', 'Simile'],
      a: 2,
      e: 'This is a metaphor — direct comparison, no like or as.',
      full: 'The pen is mightier than the sword is a metaphor attributed to the English novelist Edward Bulwer-Lytton (1839). The pen stands for the power of writing, communication, and ideas. The sword stands for military force and physical violence.\n\nThe statement says that writing and ideas (the pen) have greater power to change the world than physical force (the sword). It is a direct comparison — the pen IS mightier. There is no "like" or "as" making it a simile. It is not an exaggeration (hyperbole). There is no sound repetition (alliteration). The figure of speech is metaphor.',
      h: 'No like or as. Direct comparison = which device?',
    },
    {
      yr: 2024,
      q: 'A flashback in literature refers to',
      o: [
        'A bright light effect',
        'A scene set in the past',
        'A dream sequence',
        'A fight scene',
      ],
      a: 1,
      e: 'A flashback interrupts the current story to depict past events.',
      full: "Narrative structure does not always follow chronological order. A flashback is a technique where the narrative is temporarily interrupted to present a scene from an earlier time — before the current story timeline.\n\nFlashbacks are used to reveal backstory, explain a character's motivations, or provide context for current events. In a film, a character might suddenly remember their childhood as the camera cuts to that memory. In a novel, a chapter might open in the present then drift back years.\n\nThe opposite is a flash-forward (or prolepsis) — jumping ahead to future events. A dream sequence is imagined, not remembered. A fight scene is action, not a time-shift technique.",
      h: 'Flash = sudden. Back = into the past.',
    },
    {
      yr: 2023,
      q: 'An antagonist is',
      o: [
        'The hero',
        'The main character',
        'The character who opposes the protagonist',
        'The narrator',
      ],
      a: 2,
      e: 'The antagonist is the character who opposes or creates conflict for the protagonist.',
      full: "Every compelling story needs conflict. The antagonist is the character (or force) that opposes the protagonist, creating the central conflict that drives the plot.\n\nThe antagonist need not be a villain in the traditional sense. It can be any character whose goals or actions conflict with the protagonist's goals. In some stories, society, nature, or even the protagonist's own inner demons serve as the antagonist.\n\nIn Chinua Achebe's Things Fall Apart, the colonial forces and changing society serve as antagonists to Okonkwo. In Macbeth, Macduff is an antagonist to the protagonist Macbeth (who is himself a villain but the protagonist because the story follows him).",
      h: 'Opposite of protagonist. Who opposes the hero?',
    },
    {
      yr: 2022,
      q: 'Alliteration is the repetition of',
      o: [
        'End sounds',
        'Vowel sounds',
        'Initial consonant sounds',
        'Middle sounds',
      ],
      a: 2,
      e: 'Alliteration is the repetition of the same consonant sound at the beginning of nearby words.',
      full: 'Alliteration is a sound device in poetry and prose. It occurs when two or more words in close succession begin with the same consonant sound. The effect is musical, memorable, and often creates emphasis.\n\nExamples: "Peter Piper Picked a Peck of Pickled Peppers" — the P sound. "She sells sea shells by the sea shore" — the S and SH sounds. "Fearful, frantic, and furious" — the F sound.\n\nAlliteration is about initial sounds, not letters. "Kneel" and "Night" alliterate on the N sound even though both begin with K. It is specifically the CONSONANT sound at the beginning that must repeat — not end sounds (rhyme) or vowel sounds (assonance).',
      h: 'Peter Piper Picked — which sound repeats?',
    },
    {
      yr: 2024,
      q: 'A tragedy typically ends with',
      o: [
        'A wedding',
        "The hero's triumph",
        "The hero's downfall or death",
        'Comic resolution',
      ],
      a: 2,
      e: "Tragedy ends with the protagonist's downfall, suffering, or death.",
      full: "Tragedy is one of the oldest dramatic forms, originating in ancient Greece. The tragic form follows a protagonist of high status or noble character who, through a combination of fate, circumstances, and usually a fatal flaw (hamartia), is brought to ruin.\n\nAristotle defined tragedy as the imitation of a serious action that produces catharsis — the emotional purging of pity and fear in the audience. The audience feels pity for the suffering protagonist and fear because they recognise the possibility of such a fate in themselves.\n\nShakespeare's great tragedies — Hamlet, Macbeth, Othello, King Lear — all end with the death or destruction of the central figure. A comedy, by contrast, typically ends with harmony, reconciliation, and often a wedding.",
      h: "Think Shakespeare's tragedies — Hamlet, Macbeth. How do they end?",
    },
    {
      yr: 2023,
      q: 'Wole Soyinka won the Nobel Prize for Literature in',
      o: ['1976', '1986', '1996', '2006'],
      a: 1,
      e: 'Wole Soyinka became the first African to win the Nobel Prize in Literature in 1986.',
      full: "Wole Soyinka is Nigeria's most celebrated writer and one of Africa's greatest literary figures. He is a playwright, novelist, poet, and political activist. His major works include the plays Death and the King's Horseman, A Dance of the Forests, and The Lion and the Jewel, as well as the memoir Ake: The Years of Childhood.\n\nIn 1986, he was awarded the Nobel Prize in Literature, becoming the first African to receive this honour. The Nobel Committee recognised his wide cultural perspective and poetic overtones in crafting the drama of existence.\n\nSoyinka was also a vocal critic of military dictatorship in Nigeria and was imprisoned and exiled for his political activism.",
      h: 'First African Nobel laureate for Literature. Decade of the 1980s.',
    },
    {
      yr: 2022,
      q: 'A sonnet has how many lines?',
      o: ['10', '12', '14', '16'],
      a: 2,
      e: 'A sonnet is a 14-line poem, traditionally written in iambic pentameter.',
      full: 'The sonnet is one of the most enduring and disciplined forms in English poetry. It has exactly 14 lines and is traditionally written in iambic pentameter — a rhythm pattern of five unstressed-stressed syllable pairs per line (da-DUM da-DUM da-DUM da-DUM da-DUM), giving each line 10 syllables.\n\nThere are two main sonnet types: the Petrarchan (Italian) sonnet, with an 8-line octave followed by a 6-line sestet, and the Shakespearean (English) sonnet, with three 4-line quatrains followed by a 2-line couplet. Shakespeare wrote 154 sonnets.\n\nKnow the number 14 — it appears in many JAMB questions about the sonnet form.',
      h: "Shakespeare's sonnets have exactly how many lines?",
    },
    {
      yr: 2024,
      q: 'Onomatopoeia is when a word',
      o: [
        'Means its opposite',
        'Sounds like what it describes',
        'Is an exaggeration',
        'Gives human traits to objects',
      ],
      a: 1,
      e: 'Onomatopoeia uses words that phonetically imitate the sound they describe (buzz, crash, hiss).',
      full: 'Onomatopoeia is a fascinating figure of speech — words that actually sound like what they mean. The word itself comes from Greek: onoma (name) + poiein (to make). Onomatopoeic words imitate the natural sounds they describe.\n\nExamples: buzz (sounds like a bee), crash, bang, hiss, sizzle, drip, murmur, crackle, gurgle, thud. In poetry, onomatopoeia creates vivid sensory effects — the sound of the words reinforces the meaning.\n\nThe defining test: does the word sound like what it means? If yes, it is onomatopoeia. This is different from a simile (uses like/as), a metaphor (direct comparison), or personification (human qualities to non-human things).',
      h: 'Buzz, crash, hiss — these words sound like what?',
    },
    {
      yr: 2023,
      q: 'The setting of a story refers to',
      o: [
        'The main character',
        'The plot twist',
        'The time and place of the action',
        'The theme',
      ],
      a: 2,
      e: 'Setting refers to the time, place, and social environment in which the story takes place.',
      full: "Setting is more than just the physical location of a story. It encompasses three dimensions: place (where the story happens — a village, a city, a jungle, a classroom), time (when it happens — historical period, season, time of day), and social environment (the cultural, political, and social conditions that shape characters' lives).\n\nSetting is crucial to understanding literature because it shapes character behaviour, creates atmosphere, provides context for conflicts, and can itself become symbolic. In Things Fall Apart, the Igbo village setting in pre-colonial Nigeria is inseparable from the themes of cultural identity and colonial disruption.\n\nA plot twist is something that happens, not where or when. The main character is the protagonist. The theme is the central message.",
      h: 'Where and when does the story happen?',
    },
    {
      yr: 2022,
      q: 'A biography is a written account of',
      o: [
        'Fictional events',
        "A real person's life written by another",
        'An imaginary character',
        'A historical event',
      ],
      a: 1,
      e: "A biography is a detailed written account of a real person's life, written by someone else.",
      full: "The word biography comes from Greek: bios (life) + graphia (writing). A biography is a detailed account of a real person's life, researched and written by another author.\n\nAn autobiography is similar but written by the person themselves about their own life (auto = self). A memoir is a type of autobiography focused on a specific period or aspect of the writer's life. A novel is fictional. A historical account describes events rather than a single person's life.\n\nFamous biographies include Walter Isaacson's Steve Jobs and Robert Caro's series on Lyndon B. Johnson. The key elements: real person, real events, written by someone other than the subject.",
      h: 'Bio = life. Graphy = writing. Written by whom?',
    },
    {
      yr: 2024,
      q: 'Which of these is a device used to create humour?',
      o: ['Elegy', 'Satire', 'Dirge', 'Epitaph'],
      a: 1,
      e: 'Satire uses humour, irony, and exaggeration to criticise or mock people or society.',
      full: "Satire is a literary and dramatic genre that uses wit, irony, exaggeration, and ridicule to expose and criticise human folly, vice, corruption, and absurdity — particularly in politics and society. The goal is not just to entertain but to provoke thought and encourage reform.\n\nFamous satirical works include Jonathan Swift's Gulliver's Travels (mocking 18th-century politics), Wole Soyinka's plays (criticising post-colonial Nigerian society), and the TV series Yes Minister (satirising British bureaucracy).\n\nAn elegy mourns the dead. A dirge is a song of mourning. An epitaph is words inscribed on a gravestone. Only satire uses humour and mockery for social criticism.",
      h: 'Which literary form uses mockery and wit?',
    },
    {
      yr: 2023,
      q: 'Blank verse is poetry written',
      o: [
        'Without any structure',
        'In rhyming couplets',
        'In iambic pentameter without rhyme',
        'In free verse',
      ],
      a: 2,
      e: 'Blank verse is unrhymed iambic pentameter — structured rhythm but no end rhyme.',
      full: "Blank verse is a specific poetic form that has a regular rhythmic structure (iambic pentameter — five unstressed-stressed beats per line, 10 syllables) but does NOT rhyme at the line endings. It sounds natural and speech-like while maintaining poetic structure.\n\nShakespeare wrote most of his dramatic dialogue in blank verse. Milton's Paradise Lost is written in blank verse. The lack of rhyme allows for natural-sounding speech while the iambic rhythm provides a musical, elevated quality.\n\nFree verse has no fixed rhythm AND no rhyme. A rhyming couplet has rhyme but may or may not have fixed metre. Blank verse is the specific combination of iambic pentameter WITHOUT end rhyme.",
      h: 'Iambic pentameter + no rhyme = which poetic form?',
    },
    {
      yr: 2022,
      q: 'A dirge is a song or poem of',
      o: ['Celebration', 'Mourning', 'Love', 'War'],
      a: 1,
      e: 'A dirge is a mournful song or poem written to lament the dead.',
      full: 'A dirge is a slow, solemn song or poem of mourning, traditionally sung or read at funerals or in memory of the dead. It is an expression of grief, loss, and sadness.\n\nThe word comes from the Latin dirige (direct), the first word of a traditional antiphon sung at Catholic funeral services. In literature, dirges appear in plays and poems as expressions of grief.\n\nAn elegy is a reflective poem mourning a specific dead person. A dirge is more specifically a song or short poem with a mournful, musical quality sung at or about death. Both belong to the literature of grief, but the dirge emphasises the song-like, musical quality of lamentation.',
      h: 'Funerals use dirges. What emotion do they express?',
    },
    {
      yr: 2024,
      q: "Chinua Achebe's Things Fall Apart is set among the",
      o: ['Yoruba', 'Hausa', 'Igbo', 'Efik'],
      a: 2,
      e: 'Things Fall Apart is set among the Igbo people of Nigeria, centred on the character Okonkwo.',
      full: 'Things Fall Apart (1958) by Chinua Achebe is one of the most important novels ever written about Africa. It tells the story of Okonkwo, a proud, strong, and successful warrior in the Igbo village of Umuofia in southeastern Nigeria, in the late 19th century.\n\nThe novel depicts the rich, complex Igbo culture and community — its religion, politics, family structure, and values — before and during the arrival of Christian missionaries and British colonial administration. The title comes from W.B. Yeats\'s poem "The Second Coming" — suggesting the disintegration of a world and identity.\n\nThe Igbo ethnic group is the third largest in Nigeria. Okonkwo is not Yoruba, Hausa, or Efik.',
      h: 'Which ethnic group is Okonkwo from in Things Fall Apart?',
    },
    {
      yr: 2023,
      q: 'A couplet consists of',
      o: [
        'One line',
        'Two consecutive rhyming lines',
        'Three lines',
        'Four lines',
      ],
      a: 1,
      e: 'A couplet is a pair of successive lines of verse that rhyme.',
      full: 'A couplet is the simplest unit of rhyme in poetry — two consecutive lines that end with rhyming words. Couplets create a satisfying sense of completion and balance.\n\nShakespeare frequently ended his sonnets with a rhyming couplet that summarises or twists the meaning of the preceding lines — called the final couplet or closing couplet.\n\nA heroic couplet is a couplet written in iambic pentameter, commonly used by poets like Alexander Pope. An open couplet does not end with a full stop and runs on to the next lines. But the defining feature is always two lines — couple = two — ending with rhyming words.',
      h: 'Couple = two. Rhyming pair of lines.',
    },
    {
      yr: 2022,
      q: 'The theme of a literary work is',
      o: [
        "The author's name",
        'The central idea or message',
        'The setting',
        'The plot summary',
      ],
      a: 1,
      e: 'The theme is the central, underlying idea or message that the author communicates through the work.',
      full: 'The theme of a literary work is its central insight about human nature, society, or the human condition — the deeper meaning beneath the surface of the plot and characters. A story about war might have themes of bravery and futility. A love story might explore jealousy and sacrifice.\n\nTheme is different from plot (what happens), setting (where and when), or character (who). The theme is WHY it matters — what the author wants the reader to think about or understand after experiencing the work.\n\nThings Fall Apart has themes of colonialism and cultural loss, masculinity and tragic pride, tradition versus change. These are universal human concerns explored through specific Igbo characters and events.',
      h: 'What message is the whole story trying to convey?',
    },
    {
      yr: 2024,
      q: 'An elegy is a poem written to',
      o: [
        'Celebrate a birthday',
        'Mourn someone who has died',
        'Praise a king',
        'Mock an enemy',
      ],
      a: 1,
      e: 'An elegy is a serious reflective poem mourning the death of a particular person.',
      full: "The elegy is a poem that mourns the death of a specific person and reflects on loss, grief, and often the broader meaning of death and mortality. Unlike a dirge (which is song-like and performed), an elegy is a more private, meditative poetic form.\n\nFamous elegies include Milton's Lycidas (mourning a drowned friend), Tennyson's In Memoriam (mourning his friend Arthur Hallam), and Wole Soyinka's Abiku (reflecting on child mortality in Yoruba belief).\n\nAn elegy for a birthday would be an oxymoron — birthdays celebrate life. Praising a king is a panegyric. Mocking an enemy is invective or satire. An elegy is specifically a lament for someone who has died.",
      h: 'Elegies are written in memory of the dead.',
    },
    {
      yr: 2023,
      q: 'A metaphor directly compares two things',
      o: [
        'Using like or as',
        'Without using like or as',
        'Using rhyme',
        'Using repetition',
      ],
      a: 1,
      e: 'A metaphor makes a direct comparison without the words like or as.',
      h: 'Direct comparison, no like or as.',
    },
    {
      yr: 2022,
      q: 'Deus ex machina means',
      o: [
        'God is everywhere',
        'An unlikely solution introduced to resolve a plot',
        'A type of rhyme',
        'A dramatic monologue',
      ],
      a: 1,
      e: 'Deus ex machina is an unlikely or improbable device introduced to solve a difficult plot situation.',
      full: "Deus ex machina is Latin for 'god from the machine.' It refers to a plot device in which an apparently unsolvable problem is suddenly resolved by a convenient, unexpected, or improbable occurrence — often criticised as poor or lazy storytelling.\n\nThe term originates from ancient Greek theatre, where a machine (mechane) would literally lower an actor playing a god onto the stage to resolve the plot. The audience saw it as an artificial, unsatisfying solution.\n\nModern examples: a character in mortal danger who is inexplicably rescued by someone who arrives at exactly the right moment with no prior setup in the story. Good storytelling avoids deus ex machina by preparing solutions organically within the narrative.",
      h: 'Latin for a sudden, convenient resolution to an impossible problem.',
    },
    {
      yr: 2024,
      q: 'Which narrative perspective uses he/she/they?',
      o: ['First person', 'Second person', 'Third person', 'Omniscient'],
      a: 2,
      e: 'Third person narration uses he, she, or they and views the story from outside the characters.',
      full: "Narrative perspective determines who tells the story and what information the reader has access to.\n\nIn third person narration, the story is told from outside the characters using pronouns he, she, they, or character names. The narrator is not a character in the story.\n\nThird person limited: the narrator sees into the mind of ONE character only — we know that character's thoughts but not others'.\nThird person omniscient: the narrator sees into ALL characters' minds and knows everything happening everywhere simultaneously.\n\nFirst person uses I. Second person uses you (rare in fiction). Third person uses he/she/they — and is the most common narrative perspective in literary fiction.",
      h: 'He said, she went, they arrived — which person?',
    },
    {
      yr: 2023,
      q: 'A foil character is one who',
      o: [
        'Is the main villain',
        'Helps the hero physically',
        'Contrasts with the protagonist to highlight their traits',
        'Narrates the story',
      ],
      a: 2,
      e: 'A foil is a character whose contrasting traits highlight the qualities of another character.',
      full: "A foil is a character who, by contrast, makes the main character's traits more visible and distinct. The word comes from the metalworking term for a thin sheet of metal placed behind a gemstone to make it shine more brightly.\n\nIn Hamlet, Laertes is a foil to Hamlet. Both lose their fathers and seek revenge, but Laertes acts immediately and decisively while Hamlet agonises and delays. The contrast throws Hamlet's indecisiveness into sharp relief.\n\nIn Pride and Prejudice, Jane's unguarded optimism serves as a foil to Elizabeth's sharp, sometimes cynical wit. The foil need not be the villain — any character whose differences highlight the protagonist's characteristics can serve this function.",
      h: "A foil creates contrast to highlight another character's traits.",
    },
    {
      yr: 2022,
      q: 'The falling action in a plot comes after',
      o: [
        'The exposition',
        'The rising action',
        'The climax',
        'The resolution',
      ],
      a: 2,
      e: 'Falling action follows the climax — the tension begins to decrease as the story moves toward resolution.',
      full: "The plot of a story typically follows a five-part structure often called Freytag's Pyramid: Exposition (introduction) → Rising Action (building conflict and tension) → Climax (peak of tension, turning point) → Falling Action (tension decreasing, consequences unfolding) → Resolution/Denouement (final outcome, loose ends tied).\n\nFalling action occurs after the climax — the main conflict has been decided, and the story is winding toward its conclusion. Events in the falling action typically show the consequences of the climactic decision or event.\n\nIn Romeo and Juliet, the falling action begins after the deaths of Romeo and Juliet, as the Prince, Montagues, and Capulets process what has happened and reconcile.",
      h: 'Climax is the peak. What comes after the peak?',
    },
  ];
